import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { ColorChecker } from '../Helpers/Functions/ColorChecker'

export default function IframeCheckout({page, projects, host, team, redirect_view}) {
    const [amount, setAmount] = useState(0)
    const [projectOptions, setProjectOptions] = useState(page.checkout_projects)
    const [selectedProject, setSelectedProject] = useState(projectOptions[0])
    const [buttonColor, setButtonColor] = useState(page.button_color)
    const [buttonTextColor, setButtonTextColor] = useState('white')
    const defaultDonationAmounts = [{id: 1, value: 1000}, {id: 2, value: 500}, {id: 3, value: 200}, {id: 4, value: 100}, {id: 5, value: 50}, {id: 6, value: 25}];
    let donationAmounts = page.suggested_amounts && page.suggested_amounts.length > 0 ? page.suggested_amounts : defaultDonationAmounts

    useEffect(() => {
        const defaultProject = projectOptions.find(project => project.default === true);
        if (defaultProject) setSelectedProject(defaultProject);

        let result = ColorChecker(buttonColor);
        if (result == true) setButtonTextColor('black');
    }, [])

    const projectData = (id) => {
        let projectArray = projects || []
        let data = projectArray.find(item => item.id === Number(id))
        return data
    }

    const getAmounts = () => {
        if (amount) {
            if (page.pass_processing_fee && page.target_type === 'monthly') {
                let fee = amount * 0.034 + 0.30
                return {fee: fee, amount: parseFloat(amount) + parseFloat(fee)}
            }

            if (page.pass_processing_fee && page.target_type === 'one-time') {
                let fee = amount * 0.029 + 0.30
                return {fee: fee, amount: parseFloat(amount) + parseFloat(fee)}
            }
            return {fee: 0.00, amount: amount}
        } else {
            return {fee: 0.00, amount: 0.00}
        }
    }


    if (redirect_view) {
        return (
            <a
                className="btn"
                style={{
                    backgroundColor: page.button_color,
                    borderColor: page.button_color,
                    color: buttonTextColor,
                    display: 'block', 
                    padding: '1rem 2rem',
                    textAlign: 'center',
                    textDecoration: 'none',
                    boxSizing: 'border-box'
                }}
                href={page.iframe_src}
                target='_top'
            >
                {page.button_text ? page.button_text : 'Donate & Support'}
            </a>
        )
    }

  return (
    <div
        style={{height: '100vh'}}
    >
        {page.button_redirect &&
            <div className='text-center' style={{paddingTop: '30px', marginBottom: '50px'}}>
                {team.logo_url && (
                    <div className="logo logo-sm">
                        <img src={team.logo_url} alt={team.name} style={{height: '225px'}} />
                    </div>
                )}
                {!team.logo_url &&
                    <h3>{team.name}</h3>
                }
            </div>
        }
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: page.button_redirect ? '' : '100vh'
            }}
            >
            <div className="main-content">
                <div
                style={{
                    width: '100%',
                    maxWidth: '400px',
                    minWidth: '300px',
                    height: 'fit-content',
                }}
                className="card"
                >
                <div className="card-body pt-2 pl-5 pr-5 text-center card-border">
                    <h3 className="mb-5 mt-5">Donate Today!</h3>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}
                        className='mb-3'
                    >
                    {donationAmounts.sort((a, b) => b.value - a.value).map((donation) => (
                        <button
                            key={donation.value}
                            className="btn mb-2 no-hover-change"
                            style={{
                                backgroundColor: page.button_color,
                                borderColor: page.button_color,
                                color: buttonTextColor,
                                width: '30%'
                            }}
                            onClick={() => setAmount(donation.value)}
                        >
                        ${donation.value}
                        </button>
                    ))}
                    </div>

                    <div style={{ textAlign: 'left' }} className="mb-2">
                    <div className="row">
                        <div className="col-md-12">
                        <div className="form-group" style={{ padding: '0px' }}>
                            <label htmlFor="name">
                            Donation Amount (USD
                            {page.target_type === 'monthly' ? '/Month' : ''}):
                            </label>
                            <div className="input-group">
                            <input
                                type="number"
                                step="1"
                                min="2"
                                className="form-control"
                                name="name"
                                id="name"
                                placeholder="Amount"
                                value={amount}
                                onChange={(event) => setAmount(event.target.value)}
                            />
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                        <div className="form-group" style={{ padding: '0px' }}>
                            <label htmlFor="name">Designate To:</label>
                            <Select
                                className='w-100'
                                classNamePrefix="select-groups"
                                onChange={(option) => setSelectedProject(option)}
                                options={projectOptions}
                                getOptionLabel={(option) => `${projectData(option.id).name}`}
                                getOptionValue={(option) => option.id}
                                value={selectedProject}
                            />
                        </div>
                        </div>
                    </div>

                    <div className='mt-2'>
                        {page.pass_processing_fee && 
                            <span>Processing Fee: $<span id="fee">{parseFloat(getAmounts().fee).toFixed(2)}</span><br /></span>
                        }
                        <strong>Total: $<span id="total">{parseFloat(getAmounts().amount).toFixed(2)} {page.target_type === 'monthly' ? '/ Month' : ''}</span></strong>
                    </div>  

                    <div className="mt-3">
                        <a
                            className="w-100 btn"
                            style={{
                                backgroundColor: page.button_color,
                                borderColor: page.button_color,
                                color: buttonTextColor,
                            }}
                            href={`/sponsor/${team.id}/${selectedProject.id}/${page.id}/signup/new?amount=${amount}&donation_type=${page.target_type}`}
                            disabled={!selectedProject || !amount || amount < 2}
                            target='_top'
                        >
                        {page.button_text ? page.button_text : 'Donate & Support'}
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}
